exports.getParamId = (props) => props.match.params.id;
exports.getParam = (props, param) => props.match.params[param];
const setCookie = (cname, cvalue, remember) => {
  const d = new Date();
  let expires;
  if (remember) {
    d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
    expires = `expires=${d.toUTCString()}`;
  } else {
    expires = "expires=";
  }
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

const getCookie = (cname) => {
  const name = `${cname}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

exports.checkCookie = (cname) => {
  const user = getCookie(cname);
  if (user !== "") {
    return true;
  }
  return false;
};

exports.noWhitespaceRule = {
  validator(_, value) {
    if (value && value.trim() !== "") {
      return Promise.resolve();
    }
    return Promise.reject("Only whitespace not allow.");
  },
};

// Function to format input with inch symbol
exports.formatWithInchSymbol = (value) => {
  if (typeof value === "string" && value.trim() !== "") {
    const trimmedValue = value.trim();
    if (!trimmedValue.endsWith('"')) {
      return trimmedValue + '"';
    }
    return trimmedValue;
  }
  return "";
};
// Validation function for correct size format (single number or range)
exports.validateSizeFormat = (value) => {
  const sizeRegex = /^\d+(\-\d+)?|^\d+\/\d+$/;
  return sizeRegex.test(value);
};

exports.notValidPhoneNumberRule = {
  validator(_, value) {
    if (value && value.replace(/[^0-9]/g, "").length === 10) {
      return Promise.resolve();
    }
    return Promise.reject("Input Phone Number is not Valid");
  },
};
exports.setCookie = setCookie;
exports.getCookie = getCookie;
